import React from "react";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { useHistory, useParams, useLocation } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) => ({
  cardMedia: {
    paddingTop: "100%",
  },
  cardContent: {
    height: "118px",
    padding: theme.spacing(1),
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  cardActions: {
    flexDirection: "column",
    padding: theme.spacing(1, 0, 0),
  },
  button: {
    margin: theme.spacing(1, 0, 2),
  },
}));

export interface IBundleProps {
  id: string;
  title: string;
  subtitle?: string;
  imageUrl: string;
  defaultPrice: number;
  position: number;
  categories: number[];
}

export default function Bundle(props: IBundleProps) {
  const classes = useStyles();
  const history = useHistory();
  const params = useParams<{ id: string }>();
  const location = useLocation();

  const handleGoTo = () => {
    history.push(`/selling-area/${params.id}/bundle/${props.id}${location.search}`);
  };

  return (
    <Card>
      <CardActionArea onClick={handleGoTo}>
        <CardMedia className={classes.cardMedia} image={props.imageUrl} title={props.title} />
        <CardContent className={classes.cardContent}>
          <Typography variant="subtitle1" color="textPrimary">
            {props.title}
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions disableSpacing className={classes.cardActions}>
        <Typography variant="h6" color="textPrimary">
          € {props.defaultPrice }
        </Typography>
        <Button
          className={classes.button}
          color="primary"
          variant="contained"
          onClick={handleGoTo}
        >
          VAI
        </Button>
      </CardActions>
    </Card>
  );
}
